import React, { useState } from "react";
import { Calculator as CalcIcon, CheckCircle2, MousePointerClick, BarChart3, ChevronRight } from "lucide-react";
import { toast } from "sonner";
import { lpErr } from "@/components/portal/lp/lpApi";
import { PortalScreen } from "@/components/portal/lp/PortalScreen";
import QuestionTypes from "./QuestionTypes";
import Calculator from "./Calculator";
import Charts from "./Charts";
import { ListenBtn } from "./GedBits";

const PARTS = [
  ["how_test", "Part 1 · How the computer test works", "Practice the 5 question types", MousePointerClick, QuestionTypes],
  ["calculator", "Part 2 · Calculator practice", "Fractions, negatives, roots and powers", CalcIcon, Calculator],
  ["charts", "Part 3 · Charts and evidence", "Bar graphs, line charts and main idea", BarChart3, Charts],
];

export default function Launchpad({ d, api, voice, onChange }) {
  const [open, setOpen] = useState(null);
  const [busy, setBusy] = useState(false);
  const finish = async (k) => {
    if (busy) return;
    setBusy(true);
    try {
      const s = await api.post(`/portal/resident/ged/launchpad/${k}`);
      onChange(s);
      setOpen(null);
      voice.play(s.launchpad_done ? "launchpad_done" : "right");
      toast.success("Part complete");
    } catch (e) { toast.error(lpErr(e)); }
    setBusy(false);
  };
  const cur = PARTS.find((p) => p[0] === open);
  return (
    <div className="space-y-3" data-testid="ged-launchpad">
      <div className="flex items-center justify-between"><p className="text-base text-white/70">Three short parts before any practice tests.</p><ListenBtn voice={voice} k="welcome" /></div>
      {PARTS.map(([k, label, sub, Icon], i) => {
        const done = !!d.launchpad[k];
        return (
          <button key={k} type="button" onClick={() => { setOpen(k); voice.play(k); }} data-testid={`ged-lp-${k}`}
            className={`w-full flex items-center gap-4 rounded-2xl border-2 p-4 text-left min-h-[76px] ${done ? "border-emerald-500/60 bg-emerald-500/10" : "border-white/15 bg-white/[0.04]"}`}>
            <span className={`h-12 w-12 shrink-0 grid place-items-center rounded-xl ${done ? "bg-emerald-500 text-black" : "bg-[#d4a017]/20 text-[#d4a017]"}`}>{done ? <CheckCircle2 className="h-6 w-6" /> : <Icon className="h-6 w-6" />}</span>
            <span className="flex-1"><span className="block text-base font-semibold">{label}</span><span className="text-sm text-white/60">{done ? "Done · tap to practice again" : sub}</span></span>
            <ChevronRight className="h-5 w-5 text-white/40" />
            <span className="sr-only">{i}</span>
          </button>
        );
      })}
      {cur && <PortalScreen title={cur[1]} onBack={() => setOpen(null)} testid={`ged-screen-${cur[0]}`}>
        {busy && <p data-testid="ged-lp-saving" className="text-base text-white/70">Saving…</p>}
        {React.createElement(cur[4], { voice, onDone: () => finish(cur[0]) })}
      </PortalScreen>}
    </div>
  );
}
